import { VerificationStatuses } from 'constants/verificationStatuses';
import { STEPPER_KEYS } from '../constants';

export const getCySecActiveStepByStatus = (
  status,
  activeStep,
  passedQiuz,
  acceptedTradeWithRestrictions,
) => {
  switch (status) {
    case VerificationStatuses.EDITING.LEAD1:
      return STEPPER_KEYS.EXPERIENCE;
    case VerificationStatuses.EDITING.LEAD1_1:
      return STEPPER_KEYS.ACCOUNT;
    case VerificationStatuses.EDITING.LEAD2:
      return acceptedTradeWithRestrictions ? STEPPER_KEYS.DOCUMENTS : STEPPER_KEYS.ACCOUNT;
    case VerificationStatuses.EDITING.LEAD3:
    case VerificationStatuses.EDITING.LEAD4:
    case VerificationStatuses.REJECTED:
      return STEPPER_KEYS.DOCUMENTS;
    default:
      return activeStep || STEPPER_KEYS.PERSONAL;
  }
};
